import { getEnv } from './environment';

export const WORKTREE_AUTH_TARGET_COOKIE = 'risksmart-worktree-auth-target';

export const buildAuthRedirectUri = ({
  callbackOrigin,
  currentOrigin,
  query,
}: {
  callbackOrigin?: string;
  currentOrigin: string;
  query?: URLSearchParams;
}) => {
  const configured = callbackOrigin || currentOrigin;
  const parsed = new URL(configured);
  if (
    parsed.origin !== configured.replace(/\/$/, '') ||
    parsed.pathname !== '/' ||
    parsed.search ||
    parsed.hash
  ) {
    throw new Error(
      `REACT_APP_AUTH0_CALLBACK_ORIGIN must contain only an origin, got "${configured}"`
    );
  }
  const suffix = query?.toString();

  return `${parsed.origin}${suffix ? `?${suffix}` : ''}`;
};

export const getAuthRedirectUri = (query?: URLSearchParams) => {
  const currentOrigin = window.location.origin;
  const redirectUri = buildAuthRedirectUri({
    callbackOrigin: getEnv('REACT_APP_AUTH0_CALLBACK_ORIGIN', true),
    currentOrigin,
    query,
  });
  const callbackOrigin = new URL(redirectUri).origin;

  if (callbackOrigin !== currentOrigin) {
    document.cookie = `${WORKTREE_AUTH_TARGET_COOKIE}=${encodeURIComponent(currentOrigin)}; Path=/; Max-Age=43200; SameSite=Lax`;
  }

  return redirectUri;
};
